<template>
    <div v-if="products?.length" class="productCarousel">
        <CarouselBox
            :title="$t('siteHeader.sale.title')"
            :url="$t('header.url.category.saleAndDiscount')"
            :products="products"
            :item-list-name="itemListName"
            class="carouselBox--fullWidth"
        />
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import CarouselBox from '~/components/elements/CarouselBox.vue'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import Product from '~/models/Product/Product'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import { transformProductsToLuigisBoxItems } from '~/utils/transformProductsToLuigisBoxItems'

export default {
    components: { CarouselBox },

    props: {
        products: {
            type: Array as PropType<Product[]>,
            required: true,
        },
    },

    computed: {
        itemListName(): string {
            return GtmItemListNameEnum.HPSaleAndDiscountsCarousel
        },
    },

    mounted() {
        refreshFrequentlyActualizedData(this.products)
        LuigisBoxEventApi.sendRecommendationEvent(
            transformProductsToLuigisBoxItems(this.products),
            this.$t('siteHeader.sale.title'),
            'homepage_trends'
        )
    },
}
</script>
